export const DEFAULT_TERMS = {
    en: {
        panel: 'panel',
        panel_title: 'Panel',
        insurer: 'insurer',
        opd: 'OPD',
        ipd: 'IPD',
        file_number: 'MRN',
        card: 'card',
        wallet: 'mobile wallet',
        registration_council: 'medical council',
    },
    ar: {
        panel: 'جهة متعاقدة',
        panel_title: 'الجهة المتعاقدة',
        insurer: 'شركة التأمين',
        opd: 'العيادات الخارجية',
        ipd: 'التنويم',
        file_number: 'رقم الملف الطبي',
        card: 'بطاقة',
        wallet: 'محفظة إلكترونية',
        registration_council: 'الهيئة المهنية',
    },
    es: {
        panel: 'convenio',
        panel_title: 'Convenio',
        insurer: 'aseguradora',
        opd: 'consulta externa',
        ipd: 'hospitalización',
        file_number: 'historia clínica',
        card: 'tarjeta',
        wallet: 'billetera digital',
        registration_council: 'registro profesional',
    },
    'ur-Latn': {
        panel: 'panel',
        panel_title: 'Panel',
        insurer: 'insurance company',
        opd: 'OPD',
        ipd: 'IPD',
        file_number: 'MRN',
        card: 'card',
        wallet: 'mobile wallet',
        registration_council: 'medical council',
    },
};
export const COUNTRY_TERMS = {
    PK: { en: { registration_council: 'PMDC', wallet: 'JazzCash / Easypaisa' }, 'ur-Latn': { registration_council: 'PMDC', wallet: 'JazzCash / Easypaisa' } },
    SA: {
        en: { panel: 'insurance company', panel_title: 'Insurance company', file_number: 'file number', registration_council: 'SCFHS' },
        ar: { panel_title: 'شركة التأمين', registration_council: 'الهيئة السعودية للتخصصات الصحية' },
    },
    GB: { en: { panel: 'insurer', panel_title: 'Insurer', opd: 'outpatients', ipd: 'inpatients', file_number: 'hospital number', registration_council: 'GMC' } },
    CO: { es: { panel: 'EPS', panel_title: 'EPS', insurer: 'EPS', registration_council: 'RETHUS' }, en: { panel: 'EPS', panel_title: 'EPS', insurer: 'EPS' } },
    AE: { en: { panel: 'insurance company', panel_title: 'Insurance company', registration_council: 'DHA / DOH / MOHAP' } },
    QA: { en: { panel: 'insurance company', panel_title: 'Insurance company', registration_council: 'DHP' } },
};
export function term(key, locale, country) {
    return ((country ? COUNTRY_TERMS[country]?.[locale]?.[key] : undefined) ??
        DEFAULT_TERMS[locale]?.[key] ??
        (country ? COUNTRY_TERMS[country]?.en?.[key] : undefined) ??
        DEFAULT_TERMS.en?.[key] ??
        key);
}
export function termParams(locale, country) {
    const keys = Object.keys(DEFAULT_TERMS.en ?? {});
    return Object.fromEntries(keys.map((key) => [`term_${key}`, term(key, locale, country)]));
}
//# sourceMappingURL=terms.js.map